var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPendenciaCinza(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_29593",
    "data-name": "Grupo 29593",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2075",
    "data-name": "Ret\\xE2ngulo 2075",
    width: 42,
    height: 42,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4422",
    "data-name": "Caminho 4422",
    d: "M26.882,20.362a8.8,8.8,0,1,0,8.8,8.8A8.8,8.8,0,0,0,26.882,20.362Zm2.9,12.937L26,29.515V23.882h1.76v4.911l3.256,3.256ZM28.642,4.52h-5.6a5.26,5.26,0,0,0-9.927,0H7.52A3.531,3.531,0,0,0,4,8.041v26.4a3.531,3.531,0,0,0,3.52,3.52H18.275a11.87,11.87,0,0,1-2.5-3.52H7.52V8.041h3.52v5.28H25.122V8.041h3.52v8.942a12.375,12.375,0,0,1,3.52,1.056v-10A3.531,3.531,0,0,0,28.642,4.52ZM18.081,8.041a1.76,1.76,0,1,1,1.76-1.76A1.765,1.765,0,0,1,18.081,8.041Z",
    transform: "translate(3.041 0.76)",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendenciaCinza);
export default __webpack_public_path__ + "static/media/ic_pendencia_cinza.fe81e23616288fad03b319304154712e.svg";
export { ForwardRef as ReactComponent };